<template><div><h1>number 格式化工具</h1>
<p><code>numberComma</code>用于分割数字，默认为3位分割，一般用于格式化<code>金额</code>。</p>
<p><code>numberPad</code>用于按照位数补0</p>
<p><code>numberRandom</code>用于生成两个整数范围内的随机整数</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { numberComma, numberPad, numberRandom } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
numberComma(<span class="hljs-number">21342132</span>) <span class="hljs-comment">// 21,342,132</span>
numberComma(<span class="hljs-number">21342132</span>, <span class="hljs-number">4</span>) <span class="hljs-comment">// 2134,2132</span>
numberComma(<span class="hljs-number">21342132.234</span>) <span class="hljs-comment">// 21,342,132.234</span>

numberPad(<span class="hljs-number">1</span>) <span class="hljs-comment">// 01</span>
numberPad(<span class="hljs-number">234</span>, <span class="hljs-number">4</span>) <span class="hljs-comment">// 0234</span>

numberRandom(<span class="hljs-number">1</span>, <span class="hljs-number">7</span>) <span class="hljs-comment">// 2</span>
</code></pre>
</div></template><script>
export default {
  head: {"title":"vue 数字格式化 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// number-309.vue?5ebac7f4